angular.module('unica_workshop_session.workshop_session_services', []);